// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"006b1399","570":"9428dfc4"}[chunkId] + ".chunk.css";
};